export default "__VITE_PUBLIC_ASSET__37fc2427__"